import { component_tool, utils_tool } from '../../../tool';
import {WizTableForm} from '@/containers/common';
let { WizModal, WizSurveyAudience, WizTypography, WizRow,WizPopover } = component_tool;
let { $$, checkStrLength } = utils_tool;
import { WizClassifySelect } from '../../common'
import React from 'react'
import { Alert } from 'antd';
import BatchCheck from "./batchCheck";

//配置项
let componentName = 'certApply'
let ref;
const organizationConfig = WizTableForm.Config.organization(this, {apiParams: {state: 1}})

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "证书名称",
    name: "certName",
    dataIndex: "certName",
    searchItem: {},
    tableItem: {}
  },
  {
    title: "申请状态",
    name: "checkState",
    dataIndex: "checkState",
    dict: [
      { code: 0, codeName: "已提交" },
      { code: 1, codeName: "审核通过" },//通过
      { code: 2, codeName: "审核失败" },//未通过
      // { code: 3, codeName: "未提交" },
    ],
    searchItem: {
      type: "select"
    },
  },
  {
    title: "申请人",
    name: "applyName",
    searchItem: {},
  },
  {
    title: "姓名",
    name: "fullName",
    searchItem: {},
  },
  {
    title: "账号",
    name: "userName",
    searchItem: {},
  },

  {
    title: "学员账号",
    name: "userName",
    tableItem: {},
  },
  {
    title: "学员姓名",
    name: "fullName",
    tableItem: {},
  },
  {
    title: "身份证号/工号",
    name: "idCard",
   // searchItem: {},
    tableItem: {},
  },
  {
    title: "任职信息",
    name: "userIdentityInfoStr",
    tableItem: {
      width: 350,
        // ellipsis: true,
        render: (text, record) => {
          let contextList = text && text.split(',').length ? text.split(',') : []
          let content = [];
          let title = ''
          contextList && contextList.length && contextList.map((d, index) => {
            if (index === 0) {
              title = d
            }
            content.push(<p key={index}>{d}</p>)
          })
          let _titleView = []
          _titleView.push(title)
          if (contextList && contextList.length > 1) {
            _titleView.push(<span className='wiz-press-font-color'> ...</span>)
          }
          return (
            <WizPopover content={content} placement="rightTop">
              {_titleView}
            </WizPopover>
          )
        }
    },
  },
  {
    title: "申请人",
    name: "applyName",
    tableItem: {},
  },
  {
    title: "申请时间",
    name: "applyDate",
    tableItem: {},
  },
  {
    title: "审核时间",
    name: "checkDate",
    tableItem: {},
  },
  {
    title: "申请状态",
    name: "checkState",
    dataIndex: "checkState",
    tableItem: {},
    dict: [
      { code: 0, codeName: "已提交" },
      { code: 1, codeName: "审核通过" },//通过
      { code: 2, codeName: "审核失败" },//未通过
      // { code: 3, codeName: "未提交" },
    ],
  },
  {
    title: "组织",
    name: "orgId",
    searchItem: {
      diy: WizTableForm,
      ...organizationConfig,
      selectType: 'radio',
    }
  },


];

const templateConfig = (date) =>{
  const {onSelect,_this} = date;
  let _onSelect = (key, rows) => {
    onSelect && onSelect(key, rows);
    ref && ref.getSelectRows(rows)
  };
  let initRows = () => {
    return _this.state.selectedClassResultRows
  };
  return {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        cols: {
          xs: 24,
          md: 12,
          xl: 8
        },
        buttonSort: ['batchReview'],
        buttons: [
          {
            key: "batchReview",
            custom: true,
            needSelect: true,
            params: { children: "批量审核", type: "info" },
            customOnClick: {
              key: "modal",
              params: {
                modalKey:new Date().getTime(),
                modalParams: {
                  title: "批量审核",
                  footer : false,
                  diy: (e) => {
                    e.record = Object.assign({},e.record)
                    return(
                      <BatchCheck
                        {...e}
                        key={'Input'+e.record.id}
                        initRows={initRows}
                        ref={r => {
                          ref = r && r.getWrappedInstance();
                        }}
                        timeStamp={new Date().getTime()}
                      />
                    )
                  },
                  onOk: () => {
                    ref._ok();
                  },
                  onCancel: () => {
                    ref._doInitParams()
                  },
                  width: 600
                }
              }
            }

          }
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        loading: false,
        onSelect: _onSelect
      },
      rowOperateSort: ['review','look', 'viewAuditOpinion'],
      rowOperateView: [
        {
          key: "review",
          custom: true,
          params: { children: "审核"},
          customOnClick: {
            key: 'jumpPage',
            params: {
              key: 'push',
             // pathname: '/remoteAuth/studentRemoteAuthDetailList/studentRemoteAuthScore'
              pathname: '/certApply/certApplyList/certApplyAuditDetail'
            }
          },
          recordChangeParams: (record, rows) => {
            let result = { disabled: true };
            if (record.record && record.record.checkState === 0) {
              result.disabled = false
            }
            return result
          },
        },
        {
          key: "look",
          custom: true,
          params: { children: "查看"},
          customOnClick: {
            key: 'jumpPage',
            params: {
              key: 'push',
             // pathname: '/remoteAuth/studentRemoteAuthDetailList/studentRemoteAuthScore'
              pathname: '/certApply/certApplyList/certApplyAuditDetailShow'
            }
          },
          recordChangeParams: (record, rows) => {
            let result = { disabled: true };
            if (record.record && record.record.checkState != 0) {
              result.disabled = false
            }
            return result
          },
        },
        {
          key: "viewAuditOpinion",
          custom: true,
          params: { children: "查看审核意见"},
          customOnClick: {
            key: "modal",
            params: {
              modalKey: "modal"+new Date(),
              modalParams: {
                title: "查看审核意见",
                diy: (e) => {
                  e.record = Object.assign({}, e.record);
                  return (
                    <>{e.record.checkOpinion? e.record.checkOpinion : '暂无'}</>
                  )
                },
                footer:null,
                width: 500
              }
            },
            formatParams: (rows, record, filter) => {
              return { ...record };
            }
          },
          recordChangeParams: (record, rows) => {
            let result = { disabled: true };
            if (record.record && record.record.checkState != 0) {
              result.disabled = false
            }
            return result
          },
        },
      ],
      commonOperate: {
        add: true,
        delete: true,
        update: true

      }
    }
  }
}
};

const apis = {
  list: {
    path: `${componentName}/getListByPage`,
    payload: {
      key: `${componentName}@listByPage`,
      apiParams: { pageNum: 1, pageSize: 10 }
    }
  },
  update: {
    path: `${componentName}/update`,
    payload: {
      key: `${componentName}@update`,
      apiParams: {}
    }
  },
  UpdateProgramStatus: {
    path: `${componentName}/UpdateCertState`,
    payload: {
      key: `${componentName}@UpdateCertState`,
      apiParams: {}
    }
  }


}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
